import { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";

import Spinner from "../../../../components/Spinner";

const TabCertificate = ({ selectedItem }) => {
    const [pdfData, setPdfData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const zoomPluginInstance = zoomPlugin();
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;

    const fullScreenPluginInstance = fullScreenPlugin();
    const { EnterFullScreenButton } = fullScreenPluginInstance;

    useEffect(() => {
        if (!selectedItem?.released_document_file) return;

        setLoading(true);
        setError(null);

        // Abort if component unmounts before fetch completes
        const controller = new AbortController();

        fetch(selectedItem.released_document_file, { signal: controller.signal })
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Failed to load PDF");
                }
                return res.blob();
            })
            .then((blob) => {
                const fileUrl = URL.createObjectURL(blob);
                setPdfData(fileUrl);
                setLoading(false);
            })
            .catch((err) => {
                if (err.name !== "AbortError") {
                    console.error("Error loading PDF:", err);
                    setError("Failed to load PDF");
                    setLoading(false);
                }
            });

        return () => {
            controller.abort(); // Cancel the fetch if the component unmounts
        };
    }, [selectedItem?.released_document_file]);

    return (
        <div className="col-12 mb-md-0 mb-4">
            <div className="card shadow-none">
                <div className="card-body">
                    <div className="row p-0">
                        <div className="col-md-12">
                            <table className="table table-bordered">
                                <tr className="border">
                                    <th colSpan={2} className="p-2 bg-label-primary fw-bold fs-6">
                                        Acknowledgement Certificate
                                    </th>
                                </tr>
                                <tbody>
                                    <tr>
                                        <td className="text-center">
                                            <div style={{ overflowY: "auto" }}>
                                                {loading && <div><Spinner color="primary" text={"Downloading file.."} withborder={true} /></div>}
                                                {error && <div className="text-danger">{error}</div>}

                                                {pdfData && (
                                                    <div className="pdf-viewer" style={{ maxHeight: 755 }}>
                                                        <Worker workerUrl="../js/pdf.worker.min.js">
                                                            <div className="mb-2 d-flex col-12 justify-content-center p-0">
                                                                <ZoomOutButton />
                                                                <ZoomPopover />
                                                                <ZoomInButton />
                                                                <EnterFullScreenButton plugin={fullScreenPluginInstance} />
                                                            </div>

                                                            <Viewer
                                                                fileUrl={pdfData}
                                                                plugins={[zoomPluginInstance, fullScreenPluginInstance]}
                                                            />
                                                        </Worker>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default TabCertificate;
